import { ReturnBlock } from "../../ReturnBlock";

/**
 * Math addition block. Adds left and right values together.
 */
export class SumBlock extends ReturnBlock {
    operands

    /**
     * Constructor
     * @param operands 
     */
    constructor(id: string, operands: ReturnBlock[]) {
        super(id)
        this.operands = operands;
    }

    /**
     * Evaluates the expression
     * @param {Map} varEnv variable environment
     * @returns the sum of all operands.
     */
    evalBlock(varEnv: Map<string, any>) {
        let ans: number | string = '';
        let stringMode = false;

        for (let op of this.operands) {
            console.log(op);
            let val = op.evalBlock(varEnv);

            let numVal = Number(val);
            stringMode = stringMode || isNaN(numVal);

            if (stringMode) {
                ans = String(ans) + String(val);
            } else {
                ans = Number(ans) + numVal;

            }
        }

        return ans;
    }
}
